/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personas_SubtitleInputs */



/**
* | output |
* | --- |
* | "Manage shared AI personas available to all users in your organization. Users can also create private personas for themselves." |
*
* @param {Personas_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_subtitle = /** @type {((inputs?: Personas_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwalten Sie gemeinsame KI-Personas, die allen Nutzern Ihrer Organisation zur Verfügung stehen. Nutzer können zusätzlich eigene private Personas erstellen.")
	return /** @type {LocalizedString} */ ("Manage shared AI personas available to all users in your organization. Users can also create private personas for themselves.")
});